/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Businessaddressextra2Inputs */

const de__field_businessaddressextra2 = /** @type {(inputs: _Field_Businessaddressextra2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dienstadresse-Adresszusatz`)
};

/**

* @param {_Field_Businessaddressextra2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_businessaddressextra2 = /** @type {((inputs?: _Field_Businessaddressextra2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Businessaddressextra2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_businessaddressextra2(inputs)
});
export { _field_businessaddressextra2 as "_field_businessAddressExtra" }